import Client from 'shopify-buy';

const accessToken = '9c4e2fd6650990d5ede03094254a3f98';
const domain = 'bw-restaurants-oy';
const appId = '6674841627';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js